import React from "react";
import { RCCThemeProvider } from "react-common-components";

// import light from "./styles/light";
// import dark from "./styles/dark";

const ThemeProvider: React.FC = ({children}) => (
	<RCCThemeProvider>
		{children}
	</RCCThemeProvider>
);

export default ThemeProvider;
